import React, { useEffect } from "react";
import styled from "styled-components";
import { useUserContext } from "../contexts/user";
import LoginWIthDiscordButton from "../components/Header/LoginWithDiscordButton";
import { useInventoryContext } from "../contexts/inventory";
import {
  Button,
  TextField,
  Checkbox,
  FormControl,
  Divider,
  IconButton,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import Voucher from "./Settings/Voucher";
import { Check, X } from "lucide-react";
import { axiosNSInsance } from "../utils/axios";
import _ from "lodash";
import { SOCIAL_LINKS } from "../constants/social";

const Container = styled.div`
  padding: 24px;
  max-width: 900px;
  margin: 24px auto;
  text-align: center;
  border: 2px solid rgb(255 255 255 / 10%);
  border-radius: 4px;
`;

const VouchersContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 20px;
`;

const Sum = styled.div`
  text-decoration: line-through;
  display: inline;
  color: #515151;
`;

const defaultSum = 1000;

const checkPromocode = async (code) => {
  try {
    const response = await axiosNSInsance.get(`/promocode-check/?code=${code}`);
    const data = response?.data || {};
    return data;
  } catch (error) {
    console.error("Error checking promocode:", error);
    return {};
  }
};

const text = {
  champrionship: "Formula 4 Series 2026",
};

export default function Registration() {
  const { user } = useUserContext();
  const { discounts, registered, loadProfileItems } = useInventoryContext();
  const [checked1, setChecked1] = React.useState(false);
  const [checked2, setChecked2] = React.useState(false);
  const [f4, setF4] = React.useState(false);
  const [ff1600, setFf1600] = React.useState(false);

  const [promocode, setPromocode] = React.useState("");
  const [validPromocode, setValidPromocode] = React.useState(false);
  const [promocodeDiscount, setPromocodeDiscount] = React.useState(0);
  const [loading, setLoading] = React.useState(false);
  const [globalLoading, setGlobalLoading] = React.useState(false);

  const [sum, setSum] = React.useState(defaultSum);

  const [applicationData, setApplicationData] = React.useState({});

  useEffect(() => {
    if (promocode.trim() !== "") {
      setLoading(true);
      setValidPromocode(false);
      checkPromocode(promocode).then((data) => {
        setValidPromocode(!!data.valid);
        setPromocodeDiscount(data.discount || {});
        setLoading(false);
      });
    }
  }, [promocode]);

  useEffect(() => {
    if (user) {
      setApplicationData({
        firstName: user.member?.firstName || "",
        lastName: user.member?.lastName || "",
        driverNumber: user.driver?.number || "",
      });
    }
  }, [user]);

  const handleLatinNameChange = (field) => (event) => {
    const latinValue = event.target.value.replace(/[^A-Za-z\s'-]/g, "");
    setApplicationData((prev) => ({ ...prev, [field]: latinValue }));
  };

  useEffect(() => {
    if (discounts.length > 0 || promocodeDiscount) {
      let totalDiscount = discounts.reduce((acc, item) => acc + item.discount.value, 0);
      if (totalDiscount > 100) totalDiscount = 100;
      setSum((defaultSum / 100) * (100 - totalDiscount - (promocodeDiscount?.value || 0)));
    }
  }, [discounts, promocodeDiscount]);

  useEffect(() => {
    loadProfileItems();
  }, [loadProfileItems]);

  const handleRegister = async () => {
    setGlobalLoading(true);
    const application = {
      ...applicationData,
      promocode,
      promocodeDiscount,
      discounts,
      user,
      ff1600,
      sum,
      discordUserId: user.discordUser?.discordId,
      page: window.location.href,
    };
    const response = await axiosNSInsance.post(`/register`, application);
    if (response.data.ok) {
      alert(
        "Ви успішно подали заявку на реєстрацію в турнірі! \nМи зв'яжемося з вами найближчим часом через Discord для підтвердження деталей.",
      );
    } else {
      alert(
        "Сталася помилка при реєстрації. Будь ласка, спробуйте ще раз або зверніться до модератоів через Discord.",
      );
    }
    setGlobalLoading(false);
    window.location.href = "/";
  };

  if (!user) {
    return (
      <Container>
        <div>
          <h1 style={{ fontSize: 18 }}>Реєстрація на турнір {text.champrionship}</h1>
          <p style={{ marginTop: 24 }}>Увійдіть через Discord, щоб зареєструватися на турнір.</p>
        </div>

        <div style={{ maxWidth: "300px", margin: "14px auto" }}>
          <LoginWIthDiscordButton />
        </div>
      </Container>
    );
  }

  if (user && registered) {
    return (
      <Container>
        <div>
          <h1 style={{ fontSize: 18 }}>Реєстрація на турнір {text.champrionship}</h1>
          <p style={{ marginTop: 24 }}>Ви вже подали заявку на реєстрацію на турнір.</p>
          <p style={{ marginTop: 24 }}>Очікуйте на підтвердження реєстрації в діскорді.</p>
        </div>
      </Container>
    );
  }

  return (
    <Container>
      <h1 style={{ fontSize: 18 }}>Реєстрація на турнір {text.champrionship}</h1>
      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        <TextField
          disabled={!!user.member?.firstName}
          value={applicationData.firstName || ""}
          onChange={(event) => {
            setApplicationData((prev) => ({ ...prev, firstName: event.target.value }));
          }}
          label="Ім'я"
          variant="outlined"
          color="success"
          fullWidth
        />
        <TextField
          disabled={!!user.member?.lastName}
          value={applicationData.lastName || ""}
          onChange={(event) => {
            setApplicationData((prev) => ({ ...prev, lastName: event.target.value }));
          }}
          color="success"
          label="Призвіще"
          variant="outlined"
          fullWidth
        />
        <TextField
          disabled={!!user.driver?.number}
          value={applicationData.driverNumber || ""}
          onChange={(event) => {
            setApplicationData((prev) => ({ ...prev, driverNumber: event.target.value }));
          }}
          color="success"
          label="Driver Number"
          variant="outlined"
          fullWidth
          type="number"
          maxValue={999}
        />
        <TextField
          value={applicationData.firstNameLatin || ""}
          onChange={handleLatinNameChange("firstNameLatin")}
          color="success"
          label="Ім'я латиницею"
          variant="outlined"
          fullWidth
        />
        <TextField
          value={applicationData.lastNameLatin || ""}
          onChange={handleLatinNameChange("lastNameLatin")}
          color="success"
          label="Прізвище латиницею"
          variant="outlined"
          fullWidth
        />
        <TextField
          value={applicationData.team || ""}
          onChange={(event) => {
            setApplicationData((prev) => ({ ...prev, team: event.target.value }));
          }}
          color="success"
          label="Назва команди (якщо у вас є напарник)"
          variant="outlined"
          fullWidth
          type="text"
        />

        {/* <FormControlLabel
          control={
            <Checkbox
              checked={f4}
              onChange={(event) => setF4(event.target.checked)}
              color="success"
            />
          }
          label="Зареєструватись в залік Formula 4"
        /> */}
        {/* {f4 && (
          <FormControl component="fieldset" sx={{ width: "100%" }}>
            <div style={{ fontSize: 14, fontWeight: 500, textAlign: "left" }}>
              Виберіть бажаний залік Formula 4
            </div>
            <RadioGroup
              row
              aria-label="desired-rank"
              name="desired-rank"
              value={applicationData.desiredRank || ""}
              onChange={(event) => {
                setApplicationData((prev) => ({ ...prev, desiredRank: event.target.value }));
              }}
              sx={{ gap: 1 }}
            >
              <FormControlLabel value="Gold" control={<Radio color="success" />} label="Gold" />
              <FormControlLabel value="Silver" control={<Radio color="success" />} label="Silver" />
              <FormControlLabel value="Bronze" control={<Radio color="success" />} label="Bronze" />
            </RadioGroup>
          </FormControl>
        )} */}

        {/* <FormControlLabel
          control={
            <Checkbox
              checked={ff1600}
              onChange={(event) => setFf1600(event.target.checked)}
              color="success"
            />
          }
          label="Зареєструватись в залік Formula Ford 1600"
        /> */}

        <VouchersContainer>
          {discounts.map((item) => (
            <Voucher key={item.id} {...item} />
          ))}
        </VouchersContainer>

        <div
          style={{
            marginTop: 12,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 4,
          }}
        >
          <TextField
            value={promocode || ""}
            onChange={(event) => {
              setPromocode(event.target.value.toUpperCase());
            }}
            color="success"
            label="Промокод"
            variant="outlined"
            type="text"
            style={{ width: 300 }}
          />
          <IconButton loading={loading}>
            {validPromocode ? <Check color="green" size={20} /> : <X color="red" size={20} />}
          </IconButton>
        </div>
        <div style={{ marginTop: 4, fontWeight: 400, fontSize: 12 }}>
          Сумарна знижка: {defaultSum - sum} грн
        </div>
        <div style={{ fontWeight: 600, fontSize: 18 }}>
          Вартість участі: {defaultSum > sum && <Sum>{defaultSum}</Sum>} {sum} грн
        </div>
        <Divider style={{ marginTop: 26 }} />
        <div style={{ display: "flex", alignItems: "center", gap: 1 }}>
          <input
            type="checkbox"
            id={`agree-2`}
            checked={checked2}
            onChange={(event) => setChecked2(event.target.checked)}
          />
          <label htmlFor={`agree-2`}>
            Я є в{" "}
            <a
              href={SOCIAL_LINKS.discord}
              target="_blank"
              style={{ color: "inherit" }}
              rel="noopener noreferrer"
            >
              Discord
            </a>{" "}
            та в{" "}
            <a
              href="https://members.iracing.com/membersite/member/LeagueView.do?league=11399"
              target="_blank"
              style={{ color: "inherit" }}
              rel="noopener noreferrer"
            >
              лізі
            </a>{" "}
            в симуляторі iRacing (або подав заявку)
          </label>
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: 1 }}>
          <input
            type="checkbox"
            id={`agree-1`}
            checked={checked1}
            onChange={(event) => setChecked1(event.target.checked)}
          />
          <label htmlFor={`agree-1`}>
            Я ознайомився з{" "}
            <a href="/faq" target="_blank" style={{ color: "inherit" }} rel="noopener noreferrer">
              регламентом
            </a>{" "}
            та календарем турніру та приймаю умови участі
          </label>
        </div>

        <Button
          variant="contained"
          color="success"
          style={{ fontWeight: 600 }}
          disabled={!checked1 || !checked2}
          onClick={handleRegister}
        >
          Зареєструватися
        </Button>
      </div>

      <div style={{ fontSize: 12, marginTop: 24, opacity: 0.7 }}>
        Якщо у вас є питання або потрібна допомога, будь ласка, зв'яжіться з нами через Discord.
      </div>
    </Container>
  );
}
